import React from "react";
import Article from "../components/Article";
import { listActu } from "../actions/actus";
import { connect } from "react-redux";
import Alert from "../components/Alert";
import { tempAlWait } from "../helpers";

class Blog extends React.Component {
    state = {
        articles: [],
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        }
    }

    componentDidMount() {
        document.title = "Actualités - DiscovRide | Calendriers d'affluence, Temps d'attente de parcs d'attractions (Futuroscope, Parc Asterix...)";
        this.props.handleMenu(false);
        if (this.props.canContinue) {
            this.props.listActu({nb: null});
            this.setState({
                alert: tempAlWait()
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinue != this.props.canContinue) {
            if (this.props.canContinue) {
                this.props.listActu({nb: null});
                this.setState({
                    alert: tempAlWait()
                })
            }
        }

        if (prevProps.redListActu != this.props.redListActu) {
            this.setState({
                alert: this.props.redListActu.alert,
                articles: this.props.redListActu.datas
            })
        }
    }

    render() {
        return <main className="blogp__main">
            <h2 className="main__ttl blogp__ttl">Tous les articles</h2>

            {/** Les articles **/}
            <ul className="blogp__list">
                {
                    this.state.articles.map((article, key) => {
                        return <Article
                            idtt={this.props.idtt}
                            article={article}
                            key={`article-${key}`}
                            changeAlert={(al) => {this.setState({alert: al})}}
                        />
                    })
                }
            </ul>

            <Alert alert={this.state.alert} />
        </main>
    }
}

const mapStateToProps = state => {
    return {
        redListActu: state.redListActu
    }
}

const mapDispatchToProps = {
    listActu
}

export default connect(mapStateToProps, mapDispatchToProps)(Blog);